// assets
import { IconDashboard } from '@tabler/icons';
import LanguageIcon from '@mui/icons-material/Language';

// constant
const icons = { IconDashboard };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard = {
    id: 'dashboard',
    title: 'Tổng quan',
    type: 'group',
    children: [
        {
            id: 'default',
            title: 'Chào mừng',
            type: 'item',
            url: '/',
            icon: icons.IconDashboard,
            breadcrumbs: false
        },
        {
            id: 'website-hoi-thanh',
            title: 'Website Hội Thánh',
            type: 'item',
            url: '/website-hoi-thanh',
            icon: LanguageIcon,
            breadcrumbs: false
        }
    ]
};

export default dashboard;
